/* 
$(document).ready(function() {
    
    $('a.anchor').css('scroll-margin-top', ($('.site-header')[0].offsetHeight+10)+'px');

    $(window).on('scroll resize load', function(){
       setTimeout(function(){
          $('a.anchor').css('scroll-margin-top', ($('.site-header')[0].offsetHeight+10)+'px');
       },250);
    });
    var timeoutID;
    $('nav.submenu a').click(function(e) {
      let then = $(this);
      if (timeoutID) {
       clearTimeout(timeoutID); 
      }
      timeoutID = setTimeout(function() {
        window.location = then.attr('href');
      },450);
    });
    
});
*/
$(document).ready(function() {
    $('.cmp-cookies .cmp-cookies__action-link-ok').click(function (e) {
        e.preventDefault();
        $.cookie('popup', 'seen', { expires: 100, path: '/' });
        $('.cmp-cookies').removeClass('on');
        $('.back-to-top').removeClass('back-to-top-super');
    })
    if($.cookie('popup') != 'seen' && $('.cmp-cookies').length>0){
       $('.cmp-cookies').addClass('on');
       $('.back-to-top').addClass('back-to-top-super');
    };
});

//cookie
jQuery.cookie=function(name,value,options){if(typeof value!='undefined'){options=options||{};if(value===null){value='';options.expires=-1;}
var expires='';if(options.expires&&(typeof options.expires=='number'||options.expires.toUTCString)){var date;if(typeof options.expires=='number'){date=new Date();date.setTime(date.getTime()+(options.expires*24*60*60*1000));}else{date=options.expires;}
expires='; expires='+date.toUTCString();}
var path=options.path?'; path='+options.path:'';var domain=options.domain?'; domain='+options.domain:'';var secure=options.secure?'; secure':'';document.cookie=[name,'=',encodeURIComponent(value),expires,path,domain,secure].join('');}else{var cookieValue=null;if(document.cookie&&document.cookie!=''){var cookies=document.cookie.split(';');for(var i=0;i<cookies.length;i++){var cookie=jQuery.trim(cookies[i]);if(cookie.substring(0,name.length+1)==(name+'=')){cookieValue=decodeURIComponent(cookie.substring(name.length+1));break;}}}
return cookieValue;}};


